import * as React from 'react';
import { NewbuildingCarousel, TDirection, TOnSlideChangeParams } from '@cian/frontend-newbuilding-carousel-component';
import { ArrowControls } from './parts/ArrowControls';
import { firstPaintOptions, mediaSettings } from './config';
import * as styles from './Carousel.css';
import { NoImage } from '../NoImage';

interface ICarouselProps {
  items: React.ReactNode[];
}

interface ICarouselState {
  slides: React.ReactNode[];
  currentSlide: number;
}

export class Carousel extends React.Component<ICarouselProps, ICarouselState> {
  public constructor(props: ICarouselProps) {
    super(props);

    this.state = {
      slides: this.props.items,
      currentSlide: 1,
    };
  }

  private handleSlideChange = ({ currentSlide }: TOnSlideChangeParams) => {
    this.setState({
      currentSlide,
    });
  };

  private handleArrowsClick = (direction: TDirection) => {
    this.setState({
      currentSlide: this.state.currentSlide + direction * 1,
    });
  };

  public render() {
    const { slides, currentSlide } = this.state;

    if (!slides.length) {
      return (
        <div className={styles['carousel']}>
          <NoImage />
        </div>
      );
    }

    return (
      <section className={styles['carousel']}>
        <NewbuildingCarousel
          media={mediaSettings}
          firstPaintOptions={firstPaintOptions}
          slides={slides}
          defaultCurrentSlide={currentSlide}
          onSlideChange={this.handleSlideChange}
        />

        {slides.length > 1 && (
          <ArrowControls
            disableLeft={currentSlide === 1}
            disableRight={currentSlide === slides.length}
            clickHandler={this.handleArrowsClick}
          />
        )}
      </section>
    );
  }
}
